export const BC_ACTIONS = {
    addItem: 'addItem',
    setBreadCrumbs: 'setBreadCrumbs',
    addItemWithBack: 'addItemWithBack',
}
